"use strict";

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Attractor = void 0;

var Utils_1 = require("../../../Utils");

var ParticlesInteractorBase_1 = require("../../../Core/ParticlesInteractorBase");

var Attractor =
/*#__PURE__*/
function (_ParticlesInteractorB) {
  _inherits(Attractor, _ParticlesInteractorB);

  function Attractor(container) {
    _classCallCheck(this, Attractor);

    return _possibleConstructorReturn(this, _getPrototypeOf(Attractor).call(this, container));
  }

  _createClass(Attractor, [{
    key: "interact",
    value: function interact(p1) {
      var _a;

      var container = this.container,
          distance = (_a = p1.retina.attractDistance) !== null && _a !== void 0 ? _a : container.retina.attractDistance,
          pos1 = p1.getPosition(),
          query = container.particles.quadTree.queryCircle(pos1, distance);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = query[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var p2 = _step.value;

          if (p1 === p2 || !p2.options.move.attract.enable || p2.destroyed || p2.spawning) {
            continue;
          }

          var pos2 = p2.getPosition(),
              _ref = (0, Utils_1.getDistances)(pos1, pos2),
              dx = _ref.dx,
              dy = _ref.dy,
              rotate = p1.options.move.attract.rotate,
              ax = dx / (rotate.x * 1000),
              ay = dy / (rotate.y * 1000),
              p1Factor = p2.size.value / p1.size.value,
              p2Factor = 1 / p1Factor;

          p1.velocity.x -= ax * p1Factor;
          p1.velocity.y -= ay * p1Factor;
          p2.velocity.x += ax * p2Factor;
          p2.velocity.y += ay * p2Factor;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      return particle.options.move.attract.enable;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }]);

  return Attractor;
}(ParticlesInteractorBase_1.ParticlesInteractorBase);

exports.Attractor = Attractor;